import React from "react";
export default function FieldRequired() {
  return <span className="text-section -mt-2">* Campo obbligatorio</span>;
}
